/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_ConnectedInputs */

const en_google_drive_connected = /** @type {(inputs: Google_Drive_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive is connected. You can now browse and import files.`)
};

const es_google_drive_connected = /** @type {(inputs: Google_Drive_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Drive está conectado. Ya puedes explorar e importar archivos.`)
};

/**
* | output |
* | --- |
* | "Google Drive is connected. You can now browse and import files." |
*
* @param {Google_Drive_ConnectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_connected = /** @type {((inputs?: Google_Drive_ConnectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_ConnectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_connected(inputs)
	return en_google_drive_connected(inputs)
});